<template>
    <div class="page-wrapper">
       <div class="cg-crumb">
           <btn-back />
            <span class="item">商城</span>
            <em class="gap">/</em>
            <span class="item">下单</span>
        </div>
        <div class="panelBox">
            <div class="pinkWrap">
                <div class="pinkArea">
                    <span class="text">供应商同意锁仓总数：</span>
                    <span class="red">{{lockTotal}}</span>
                    <span>件</span>
                </div>
            </div>
            <div class="panelTitle" v-if="lockTableOrderData.length>0">
                订单明细
                <span style="font-size: 12px;color:#666">该商品有{{lockTableOrderData.length}}条已成功的锁仓</span></div>
            <div class="panelContent" v-for="(list1,index) in lockTableOrderData">
                <div class="subTitle">
                    <div class="oneItem">
                        <span class="myLabel">{{index+1}}、锁仓订单号  </span>
                        <span class="text">{{list1.order_number}}</span>
                    </div>
                </div>
                <div class="oneItemCol" v-for="(item,index2) in list1.sizeColorArr_init">
                    <div class="firstDesLine">
                        <div class="left">颜色:{{item.color}}</div>
                        <div class="right">锁仓小计：{{item.colorChoseTotal}}件</div>
                    </div>
                    <div class="sizeItemBox">
                        <div class="oneCol" >
                            <!-- <div class="labelSpan">尺码</div> -->
                            <div class="labelSpan" v-for="obj in item.sizeArr">{{obj.name}}</div>
                        </div>
                        <div class="oneCol"  >
                            <!-- <div class="labelSpan">锁仓</div> -->
                            <div class="labelSpan" v-for="obj in item.sizeArr" :class="{biggerZero:obj.sizelockNumber>0}">{{obj.sizelockNumber}}</div>
                        </div>
                    </div>
                </div>
                
                
            </div>
        </div>
        <!-- 下单操作面板 -->
        <div class="panelBox">
            <div class="panelContent">
                <div class="subTitle">
                    <span class="item" style="margin-right: 25px;">定价：{{infoObj.price}}元/件 </span>
                    <span class="item">分佣比例 销售商 ：供应商={{infoObj.dealerPercent}}% ：{{infoObj.supplierPercent}}% </span>
                </div>
                <div class="minFont">下单后请及时填写核销数量</div>
                <div class="sizeControlBlock" v-for="(colorSizeList,index) in allSizeColorOptionArr">
                    <div class="sizeControl">
                        <div class="left">颜色：{{colorSizeList.color}}</div>
                        <div class="left">下单小计：{{colorSizeList.colorChoseTotal}}</div>
                        
                        <div class="right">现有库存{{colorSizeList.nowColorStock}}件</div>
                    </div>
                    <div class="sizeContent">
                        <div class="sizeLine" v-for="sizeList in colorSizeList.sizeArr">
                            <span class="left">{{sizeList.name}}</span>
                            <div class="middle">
                                <el-input-number v-model="sizeList.sizeLockNumber" size="small" 
                                :min="0" :max="sizeList.sizeMaxOrderNumber" @change="changeLockNumber"></el-input-number>
                            </div>
                            <!-- <span  class="right">锁仓数：<span :class="{biggerZero:sizeList.sizeLockNumber>0}">{{sizeList.sizeLockNumber}}</span></span> -->
                            <span  class="right" >商家库存：<span :class="{biggerZero:sizeList.sizeStockNumber>0}">{{sizeList.sizeStockNumber}}</span></span>
                            <span  class="right">最多下单：<span :class="{biggerZero:sizeList.sizeMaxOrderNumber>0}">{{sizeList.sizeMaxOrderNumber}}</span></span>
                        </div>
                        
                    </div>
                </div>
                <!-- <hr  class="hrLine"> -->
                <div class="subTitle" style="margin-top:10px;">
                    <div class="newMainTitle">
                        收货信息
                    </div>
                    <span class="item" style="margin-right: 20px;" v-if="lockAddressItem&&lockAddressItem.address_contact_name">
                     {{lockAddressItem.address_contact_name}}
                     {{lockAddressItem.address_contact_phone}}
                     {{lockAddressItem.region_province_string}}
                     {{lockAddressItem.region_city_string}}
                     {{lockAddressItem.region_district_string}}
                     {{lockAddressItem.address_string}}
                    </span>
                    <button  class="cg-btn " @click="isShowLockAddress=!isShowLockAddress">选择地址</button>
                    
                </div>
               <!-- <div class="addressControl" @click="isShowLockAddress=!isShowLockAddress">
                   <span class="plus"> </span> <span>选择地址</span>
                </div> -->
                <el-dialog :visible.sync="isShowLockAddress"   width="70%" append-to-body>
                    <div class="addressAllModalWrap">
                      <addressall :propId="lockAddressId" @chose="choseLockAddress"></addressall>
                    </div>
                </el-dialog>   
                 
                 <!-- <hr class="hrLine"> -->
          
                <div class="bottomLine">
                    <span class="mylabel">总数：</span>
                    <span class="redSpan">{{orderTotal}}</span>
                    <span>件</span>
                    <span style="margin-right: 20px;"></span>
                    <span class="mylabel">总价：</span>
                    <span class="redSpan">{{orderTotalMoney}}</span>
                    <span>元</span>
                    <button class="cg-btn red leftBtn" @click="submitClick">下单</button>
                    <button class="cg-btn " @click="backPage">取消</button>
                </div>
            </div>
        </div>
        <!-- 下单成功结果弹出框 -->
        <el-dialog                :visible.sync="isShowOrderModal"     :before-close="beforeCloseSuccess"     width="70%"     >
          <div class="modalContentWrap">
              <div class="pinkBlock">
                  <div class="title">成功下单{{orderTotal}}件</div>
                  <div class="subTitle">
                      <span class="span">销售定价：{{infoObj.price}}元/件</span>
                      <span style="margin-right: 30px;"></span>
                      <span class="span">分佣比例 </span>
                      <span class="span">销售商 ：供应商={{infoObj.dealerPercent}}% ：{{infoObj.supplierPercent}}% </span>
                  </div>
              </div>
              <div class="panelBox">
                  <div class="panelTitle">下单明细</div>
                  <div class="panelContent">
                      <!-- <div class="tableBox" v-for="(colorSizeList,index) in allSizeColorOptionArr">
                          <div class="tableHead">
                              <div class="left" >颜色：{{colorSizeList.color}}</div>
                              <div class="right">下单数量：{{colorSizeList.colorChoseTotal}}</div>
                              <div class="right" >现有库存{{colorSizeList.nowColorStock}}件</div>
                          </div>
                          <div class="tableContent" >
                              <div class="line">
                                  <span>尺码</span>
                                  <span v-for="sizeList in colorSizeList.sizeArr">{{sizeList.name}}</span>
                              </div>
                              <div class="line">
                                  <span>数量</span>
                                  <span v-for="sizeList in colorSizeList.sizeArr">{{sizeList.sizeLockNumber}}</span>
                              </div>
                          </div>
                      </div> -->
                      <div class="take-order-table ">
                          <table class="table" >
                              <thead>
                                  <tr class="th">
                                      <th width="20%">颜色</th>
                                      <th width="20%">尺码</th>
                                      <th width="20%">下单数量</th>
                                      <th width="20%">下单小计</th>
                                      <th width="20%">现有库存</th>
                                  </tr>
                              </thead>               
                              <tbody >
                                  <tr v-for="(colorSizeList,index) in allSizeColorOptionArr">
                                      <td>{{colorSizeList.color}}</td>
                                      <td>
                                          <p v-for="(item2,index2) in colorSizeList.sizeArr" class="oneTdCol">
                                              {{item2.name}}
                                          </p>
                                      </td>
                                      <td>
                                          <p v-for="(item2,index2) in colorSizeList.sizeArr" class="oneTdCol">
                                              <span :class="{red:item2.sizeLockNumber>0}">{{item2.sizeLockNumber}}</span>
                                              
                                          </p>
                                      </td>
                                      <td>{{colorSizeList.colorChoseTotal}}</td>
                                      <td>{{colorSizeList.nowColorStock}}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      
                  </div>
              </div>
              <div class="bottomLine">
                  <div class="des">下单后请及时填写核销数量</div>
                  <div class="buttonBox">
                      <button class="cg-btn red" style="margin-right: 30px;" @click="closeSuccess">继续下单</button>
                      <button class="cg-btn red red-border" @click="toOrderList">查看下单列表</button>
                  </div>
              </div>
          </div>
        </el-dialog>
    </div>
</template>

<script>
import { getOrderLockList ,getMallItemInfo,orderPurchase,noLockOrderPurchase } from '../../../api/dealer'
import {getParseInt,getNotZeroNum,getTwoPointerNumber} from '../../../utils/tools'
import { requestUserAddressList} from '../../../api/address'
import { mapGetters } from 'vuex'
import addressall from '../setting/user-address.vue'
export default {
    data() {
        return {
            tableData: [],
            lockTableOrderData:[],
            isShowOrderModal:false,
            infoObj:{},
            allSizeColorOptionArr:[],
            currentSizeColor:[],
            lockTotal:'0',
            orderTotal:'-',
            orderTotalMoney:'',
            
            lockAddressId:'',//锁仓选的地址
            isShowLockAddress:false,
            lockAddressItem:{
                address_contact_phone:"",
            },
        }
    },
    components:{
        addressall
    },
    computed: {
      ...mapGetters(['userId'])
    },
    methods: {
        getFirstAddress(){
            let _this=this
            requestUserAddressList({
                userId: this.userId
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    let addressList = res.data
                    console.log(addressList)
                    if(addressList.length>0){
                        addressList.forEach(function(item,index){
                            if(item.address_is_default=='y'){
                                _this.lockAddressItem=item
                                _this.lockAddressId=item.address_id
                                return false
                            }
                        })
                    }
                    
                    
                } 
            }).catch(err => {
                console.log(err)
            })
        },
        beforeCloseSuccess(){
            this.getMallDetail()
            this.isShowOrderModal=false
        },
        closeSuccess(){
            this.getMallDetail()
            this.isShowOrderModal=false
        },
        choseLockAddress(item){
          this.lockAddressId= item.address_id
          this.lockAddressItem=item
          this.isShowLockAddress=false
        },
        backPage(){
            this.isShowOrderModal = false
            this.$router.go(-1)
            // this.$router.back()
        },
        toOrderList(){
            this.$router.push('/dealer/order/list-take')
        },
        orderResFun(res){
            if(res.errorCode==200){
                this.$message.success("下单成功")
                this.isShowOrderModal=true
            }else{
                this.$message.error(res.errorMsg)
            }
        },
        submitClick(){
            if(this.orderTotal<=0){
                this.$message.error("下单件数不能为0")
                return false
            }
            if(this.orderTotal<this.lockTotal*10/100){
                this.$message.error("下单件数至少为锁仓总数的10%")
                 return false
            }
            if(!this.lockAddressId){
                this.$message.error("地址不能为空")
                return false
            }
            if(!confirm("确认下单吗？")){
                return false
            }
            let _this=this
            let copySizeArr=JSON.parse(JSON.stringify(_this.allSizeColorOptionArr))
            copySizeArr.forEach(function(out,outindex){
                out.sizeArr.forEach(function(inner,innerIndex){
                    inner.number=inner.sizeLockNumber
                })
            })
            let arg={
                supplierUserId:_this.itemSupplierId,
                dealerUserId:_this.userId,
                reserveInfo:JSON.stringify({group:copySizeArr}) ,//：锁仓详情数据json文本（颜色、尺码、数量等）-数据格式和我详情给你的一致，你只需要改number这个参数，其余字段都返回给我
                orderPurchaseQuantity:_this.orderTotal,
                itemId:_this.itemId,
                orderPurchaseAmount:_this.orderTotalMoney,
                orderUserAddressId:_this.lockAddressId,
            }
            console.log(arg)
            if(_this.lockTableOrderData&&_this.lockTableOrderData.length>0){//有锁仓时下单
                orderPurchase(arg).then(res=>{
                    _this.orderResFun(res)
                })
            }else{//无锁仓时下单
                noLockOrderPurchase(arg).then(res=>{
                     _this.orderResFun(res)
                })
            }
        },
        // toDetail(id){
        //     this.isShowOrderModal=false
        //     this.$router.push({ path: '/dealer/goods/detail',  query:{id:id} });
        // },
        getMallDetail() {
            let _this=this
            getMallItemInfo({
                  itemId:_this.itemId
            }).then(res =>{
                //   console.log(res)
                if(res.errorCode==200){
                    _this.infoObj=res.data[0]
                    try{
                        var percentStr=this.infoObj.item_fee_splitting
                        var percentArr=percentStr.split(",")
                        this.infoObj.dealerPercent=getTwoPointerNumber(percentArr[0]*100)
                        this.infoObj.supplierPercent=getTwoPointerNumber(percentArr[1]*100)
                    }catch(error){
                        this.infoObj.dealerPercent=0
                        this.infoObj.supplierPercent=0
                    }
                    _this.currentSizeColor=[]
                    console.log(JSON.parse(_this.infoObj.sizeArr))
                    let sizeColorArr=JSON.parse(JSON.stringify( JSON.parse(_this.infoObj.sizeArr).group))
                    sizeColorArr.forEach(function(item,index){
                        let buffer={
                            color:item.color,
                            colorId:item.colorId,
                            nowColorStock:0,//现有库存
                            sizeArr:[]
                        }
                        item.sizeArr.forEach(function(size,index2){
                            let sizeBuffer={
                                name:size.name,
                                sizeStockNumber:size.number,//商家库存：
                                // 旧属性
                                item_display_name:size.item_display_name,
                                stock_current_total_quantity:size.stock_current_total_quantity,
                                stock_grand_total_quantity:size.stock_grand_total_quantity,
                                stock_id: size.stock_id,
                                stock_item_id: size.stock_item_id,
                                stock_sale_total_quantity: size.stock_sale_total_quantity,
                                stock_unavailable_total_quantity: size.stock_unavailable_total_quantity,
                                stock_user_id:size.stock_user_id
                                
                            }
                            buffer.nowColorStock+=sizeBuffer.sizeStockNumber//计算颜色的库存总和//从详情里获取最新库存
                            buffer.sizeArr.push(sizeBuffer)
                        })
                        _this.currentSizeColor.push(buffer)
                    })
                    console.log("_this.currentSizeColor======================")
                    console.log(_this.currentSizeColor)
                    _this.getOrderLockList()
                }
            })
        },
        getOrderLockList(){
            let _this=this
            let arg={
                "supplierUserId":this.itemSupplierId,
                "dealerUserId":this.userId,
                "orderState":"1",
                "itemId": _this.itemId,
                "reserveOrderNumber":"",
                "lOrderId":""
                
            }
            getOrderLockList(arg).then(res => {
                // console.log(res)
                if(res.errorCode==200){
                   _this.lockTotal=0
                   _this.lockTableOrderData=res.data.map(function(item,index){
                       item.sizeColorArr_init=item.order_content?JSON.parse(item.order_content).group:[]
                        _this.lockTotal+=item.order_reserve_quantity
                       return item
                   })
                }else{
                    _this.lockTotal=0
                    _this.lockTableOrderData=[]
                }
                // console.log(_this.lockTableOrderData)
                 let allOption=[]
                 _this.currentSizeColor.forEach(function(item,index){
                     allOption.push(item)
                 })
                _this.lockTableOrderData.forEach(function(item,index){
                    let oneOrderArr=item.sizeColorArr_init
                    oneOrderArr.forEach(function(obj,index1){
                        // console.log(obj)
                        let buffer={
                            color:obj.color,
                            colorId:obj.colorId,
                            sizeArr:[]
                        }
                        obj.sizeArr.forEach(function(size,index2){
                            let sizeBuffer={
                                name:size.name,
                                sizeLockNumber:size.sizelockNumber,//锁仓件数：
                                
                                // 旧属性
                                item_display_name:size.item_display_name,
                                stock_current_total_quantity:size.stock_current_total_quantity,
                                stock_grand_total_quantity:size.stock_grand_total_quantity,
                                stock_id: size.stock_id,
                                stock_item_id: size.stock_item_id,
                                stock_sale_total_quantity: size.stock_sale_total_quantity,
                                stock_unavailable_total_quantity: size.stock_unavailable_total_quantity,
                                stock_user_id:size.stock_user_id
                            }
                            buffer.sizeArr.push(sizeBuffer)
                        })
                        allOption.push(buffer)
                        // console.log(allOption,'所有的sku，有重复的')
                        
                    })
                   
                })
                _this.allSizeColorOptionArr=_this.formateZero(_this.combinationAllOption(allOption)) 
                console.log(allOption,'所有的sku，有重复的')
                console.log(_this.allSizeColorOptionArr,'最终展示结果')
                _this.changeLockNumber()//计算一下总数和每个颜色的总数
            })
        },
        formateZero(arr){
            arr.forEach(function(item,index){
                item.nowColorStock=item.nowColorStock||0
                // item.colorChoseTotal=0
                item.sizeArr.forEach(function(innerItem,innerIndex){
                    innerItem.sizeLockNumber= innerItem.sizeLockNumber||0
                    innerItem.sizeStockNumber= innerItem.sizeStockNumber||0
                    innerItem.sizeMaxOrderNumber=getNotZeroNum(innerItem.sizeLockNumber)+getNotZeroNum(innerItem.sizeStockNumber)
                    
                    // item.colorChoseTotal+=innerItem.sizeLockNumber
                })
            })
            
            return arr
        },
        changeLockNumber(){//输入锁仓数量，input框
            let _this=this
            let total=0
            this.allSizeColorOptionArr.forEach(function(outerItem,outerIndex){
                outerItem.colorChoseTotal=0
                outerItem.sizeArr.forEach(function(innerItem,innerIndex){
                    outerItem.colorChoseTotal+=Number(innerItem.sizeLockNumber)
                    total+=Number(innerItem.sizeLockNumber) 
                })
            })
            _this.orderTotal=total
            _this.orderTotalMoney=parseFloat(getParseInt(_this.orderTotal)*Number(this.infoObj.price) ) 
        },
        combinationAllOption:function(arr){
            let _this=this
            let result=[]
            if(arr&&arr.length>0){
                arr.forEach(function(item,index){//包含全部选项的数组
                    let currentColorId=item.colorId
                    let thisColorIndex=-1
                    result.forEach(function(obj,rIndex){//结果数组
                        if(obj.colorId==currentColorId){//
                            thisColorIndex=rIndex
                            return false
                        }
                    })
                    // console.log(currentColorId,item.color,"是否有该颜色："+thisColorIndex)
                    if(thisColorIndex>=0){//item的这个颜色已经存在
                        let resultItem=result[thisColorIndex]
                        // console.log(resultItem,'resultItem')
                        let nowItem=item
                        // console.log(nowItem,'nowItem')
                        result[thisColorIndex]=_this.combinationTwoColorObj(resultItem,nowItem)
                    }else{//item的这个颜色不存在
                        let buffer=JSON.parse(JSON.stringify(item))
                        result.push(buffer)
                    }
                })
                return result
            }
        },
        combinationTwoColorObj(firstObj,secondObj){
            let _this=this
            let newObj={
                color:firstObj.color,
                colorId:firstObj.colorId,
                nowColorStock:getNotZeroNum(firstObj.nowColorStock,secondObj.nowColorStock),//现有库存
            }
            // if(firstObj.color=='条纹'){
            //     console.log("条纹==========================")
            //     console.log(firstObj)
            //     console.log(secondObj)
            //     console.log(this.combinationSizeArr(firstObj.sizeArr,secondObj.sizeArr))
            // }
            newObj.sizeArr=_this.combinationSizeArr(firstObj.sizeArr,secondObj.sizeArr)
            return newObj
        },
        combinationSizeArr(arr1,arr2){ //[{},{}]
            
            let _this=this
            let newArr=[]
            arr1.forEach(function(item,index){
                newArr.push(item)
            })
            arr2.forEach(function(item,index){
                newArr.push(item)
            })
            let result=[]
            newArr.forEach(function(item,index){
                let haveThisSizeIndex=-1
                result.forEach(function(t,i){
                    if(t.name==item.name){
                        haveThisSizeIndex=i
                    }
                })
                // console.log('尺码：'+item.name,haveThisSizeIndex)
                if(haveThisSizeIndex>-1){//说明这个尺码存在
                    result[haveThisSizeIndex].sizeLockNumber=getParseInt(result[haveThisSizeIndex].sizeLockNumber) + getParseInt(item.sizeLockNumber)
                    result[haveThisSizeIndex].sizeStockNumber=getNotZeroNum( result[haveThisSizeIndex].sizeStockNumber,item.sizeStockNumber) 
                    // result[haveThisSizeIndex].sizeMaxOrderNumber=getNotZeroNum(result[haveThisSizeIndex].sizeLockNumber,item.sizeLockNumber)+getNotZeroNum(result[haveThisSizeIndex].sizeStockNumber,item.sizeStockNumber) 
                }else{
                    result.push(item)
                }
            })
            return result
        },
       
        getParam(){
          this.itemId=this.$route.query.itemId  
          this.itemSupplierId=this.$route.query.itemSupplierId 
        },
        
    },
    mounted() {
    },
    created() {
      console.log(this.$route)
      this.getParam()
      this.getMallDetail()
      this.getFirstAddress()
    },
}
</script>

<style lang="scss" scoped>
    .hrLine{border:0.5px solid #e6e6e6;margin:20px 0;}
    img{outline: 1px dotted #ddd;}
    .oneItemCol{
        display: inline-block;width:250px;margin-right: 20px;margin-bottom: 20px;padding:10px;border:0.5px solid #ddd;border-radius: 4px;
        .firstDesLine{
            display: flex;
            .left{flex:1;text-align: center;}
            .right{flex:1;text-align: right;}
        }
        .sizeItemBox{
            display: flex;
            .oneCol{
                flex: 1; text-align: center;
                .labelSpan{}
            }
            // .oneCol:first-child{text-align: left;}
        }
    }
.page-wrapper {
  // padding: 24px 24px; 
  // background: #fff;
  padding-top: 16px;
  padding-bottom: 24px;
}

.subTitle{
    margin-bottom: 16px;font-size:16px ;
    .item{}
    .newMainTitle{
        font-weight: bold; font-size: 20px;margin-bottom: 10px;
    }
}
.tableBox{
    .tableHead{
        display: flex;background:#FAFAFA;padding:14px 48px;border:1px solid #E6E6E6;
        .left{flex:1;}
        .right{flex:1;text-align: right;}
    }
    .tableContent{
        border:1px solid #E6E6E6;
        .line{
            padding:24px;padding-left:48px;
            span{margin-right: 60px;}
        }
    }
}
.header-handle {
    margin-top: 24px;
    padding: 20px 24px;
    height: 28px;
    background: #fff;
    .search-box {
        float: left;
    }
    .btns {
        float: right;
    }
}
.table-wrap {
    margin-top: 24px;
    background: #fff;
    padding:20px 15px;
}

// 一个商品
.line .icon{width: 18px;height: auto;}

.buttonLine{
    padding-bottom: 40px;
    button{width: 160px;height: 40px;}
    .leftBtn{margin-right: 64px;}
}
.panelBox{
    margin-bottom:16px;
    // box-shadow:0px 3px 5px 0px rgba(220,220,220,1);
     background: #fff;padding-bottom: 24px;
    .panelTitle{color:#000;font-size: 20px;font-weight: bold;padding:24px 40px 4px;}
    .panelContent{
        color:#000;font-size: 14px;padding:0 40px;padding-top:32px;
        .oneItem{
            display: inline-block;margin-right: 140px;
            .myLabel{opacity: 0.85;}
            .text{opacity: 0.65;}
        }
    }
    &:last-child {
        margin-bottom: 0;
    }
}
.minFont{color:#999;}
.cg-crumb{background: #fff;padding:24px 24px 0;font-size: 14px;}
.sizeControlBlock{
    display: inline-block;margin:24px 0;margin-right:24px;border:1px solid #e6e6e6; vertical-align: top;
    .sizeControl{
        padding:0 6px;
        height: 36px;line-height: 36px;display: flex;border-bottom:1px solid #e6e6e6;
        .left{flex:1;}
        .right{flex:1;text-align: right;}
    }
    .sizeContent{
        padding:0 6px;
        // *{outline: 1px solid blue;}
        .sizeLine{
            display: flex;margin:9px 0; vertical-align: bottom;line-height: 32px;
            .left{width:50px;text-align: center;}
            .middle{}
            .right{text-align: left;width:140px ;padding-left: 10px;}
        }
    }
}
.addressControl{border:1px dotted #aaa;width: 660px;font-size:14px;color:#000;opacity: 0.65;height: 40px;line-height: 40px; text-align: center;
    .plus{}
}
.bottomLine{margin:29px 0;font-size: 22px;color:#333; font-weight: bold;
    .redSpan{color:#F81D22;}
    button{margin-left:40px;}
}
.pinkWrap{
    padding:0 24px;
    // border:1px solid blue;
    padding-top:16px;
}
.pinkArea{
    padding-left:24px;   height:76px; line-height: 76px;    background:rgba(255,169,88,0.05);font-size:20px;font-weight:bold;color:rgba(51,51,51,1);
    .text{}
    .red{color:#F81D22;margin-right:10px; }
}
.modalContentWrap .pinkBlock{text-align: center;   background:rgba(255,169,88,0.1);padding:20px 0;
    .title{font-size: 20px;font-weight: bold; margin-bottom: 10px;color:#333;}
    .subTitle{font-size: 12px;color:#999;margin-bottom: 8px;}
}
.modalContentWrap .panelBox{box-shadow: 0 0 0 0;}
.modalContentWrap .panelTitle{padding-bottom:10px;}
.modalContentWrap .panelContent{padding-top:0;}
.modalContentWrap .bottomLine{
    text-align: center;color:#999;font-size: 12px;
    .des{margin-bottom: 24px;}
    button{width: 160px;margin-left:0;font-size:16px;}
}
.take-order-table {
      &.scroll {
          height: 50vh;
          overflow-y: auto;
          overflow-x: visible;
      }
      .table {
        border: 1px solid #E6E6E6;
        width: 100%;
        min-width: 400px;
        border-spacing: 0;
        border-collapse: collapse;
        font-size:14px;
        tr {
          height: 50px;
        }
        tr.th {
          background: #fafafa;
        }
        tr th {
          color:rgba(0,0,0,0.85);
          font-weight: normal;
        }
        td {
          border: 1px solid #E6E6E6;
          text-align: center;
          color:rgba(0,0,0,0.85);
        }
        &.min-400 {
            min-width: 400px;
        }
      }
      &.mgt-24 {
          margin-top: 24px;
      }
      &.clearing {
          margin-top: 24px;
      }
      &.clearing tr th {
        border: 1px solid #E6E6E6;
      }
      &.clearing tr th:last-child, &.clearing tr td:last-child{
        color: #F81D22;
      }
      
    }
    .oneTdCol{padding:5px 0;}

</style>